import { getAllLayoutApi, LayoutResponseType } from '@app-store'
import { SkeletonLoader } from '@ui-kit'
import { useState, useRef, useEffect } from 'react'
import { LAYOUT_TYPE_NAMESPACE } from '../../utils/constants'
import { ListingTableProps } from '../../types/listingTable.types'
import ListingTableFromLayout, { NoDataScreen } from './ListingTableFromLayout'

export const ListingTable: React.FC<ListingTableProps> = (props) => {
  const allLayouts = useRef<LayoutResponseType[]>([])
  const [layout, setLayout] = useState(props.layout)

  const [fetchingLayouts, setFetchingLayouts] = useState(false)
  const isLoading = fetchingLayouts || !!props.isLoading

  useEffect(() => {
    const fetchLayouts = async (): Promise<LayoutResponseType[]> => {
      try {
        setFetchingLayouts(true)
        const response = await getAllLayoutApi({
          entityId: props.entityId.toString(),
          defaultValue: true,
        })

        return response.data.content ?? []
      } catch (err) {
        console.error(err)
        return []
      } finally {
        setFetchingLayouts(false)
      }
    }

    const updateLayouts = async () => {
      allLayouts.current = props.allLayouts ?? (await fetchLayouts())
      if (layout === undefined)
        setLayout(
          allLayouts.current.find(
            (layout) =>
              layout.type === LAYOUT_TYPE_NAMESPACE.LAYOUT_LISTING &&
              layout.default_value
          )
        )
      else if (
        layout.entity_id !== props.entityId ||
        layout.entity_name !== props.entityName
      )
        console.warn(
          'Wrong layout passed in ListingTable.',
          layout.entity_name,
          props.entityName
        )
    }
    if (!props.isLoading) updateLayouts()
  }, [props.entityId, props.isLoading, props.layout, props.allLayouts])
  if (!layout && !isLoading)
    return (
      props.noDataScreen?.(props.entityName ?? '') ?? (
        <NoDataScreen
          entityId={props.entityId}
          entityName={props.entityName}
          noLayout={true}
        />
      )
    )

  return (
    <>
      <div className={`${isLoading ? '' : 'hidden'}`}>
        <SkeletonLoader />
      </div>
      {!layout ? null : (
        <div className={`${isLoading ? 'hidden' : 'h-full'}`}>
          <ListingTableFromLayout
            {...props}
            key={props.entityId.toString() + '-' + layout.id?.toString()}
            layout={layout}
            allLayouts={allLayouts.current}
            tabIndex={props?.tabIndex}
            showStringFilterOptions={props.showStringFilterOptions}
            setApiFilter={props?.setApiFilter}
            apiFilter={props?.apiFilter}
            isMinHeight={props?.isMinHeight ?? true}
            caseId={props?.caseId}
            isCaseView={props?.isCaseView}
            haltActions={JSON.parse(layout?.config ?? '{}')?.haltActions}
            minHeight={props?.minHeight}
          />
        </div>
      )}
    </>
  )
}
